import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InfoCard = ({ merchant, onStatusChange }) => {
  const getStatusBadge = (status) => {
    const configs = {
      active: { color: 'bg-success/10 text-success border-success/20', label: 'Active', icon: 'CheckCircle' },
      pending: { color: 'bg-warning/10 text-warning border-warning/20', label: 'Pending', icon: 'Clock' },
      suspended: { color: 'bg-error/10 text-error border-error/20', label: 'Suspended', icon: 'XCircle' },
      inactive: { color: 'bg-muted text-muted-foreground border-border', label: 'Inactive', icon: 'MinusCircle' }
    };
    const config = configs?.[status] || configs?.pending;
    return (
      <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium border ${config?.color}`}>
        <Icon name={config?.icon} size={14} />
        {config?.label}
      </span>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date?.toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' });
  };

  const infoItems = [
    { label: 'Email', value: merchant?.email, icon: 'Mail' },
    { label: 'Phone', value: merchant?.phone || '-', icon: 'Phone' },
    { label: 'Business Type', value: merchant?.businessType || '-', icon: 'Briefcase' },
    { label: 'Address', value: merchant?.address || '-', icon: 'MapPin' },
    { label: 'Registered', value: formatDate(merchant?.registrationDate), icon: 'Calendar' },
    { label: 'Activated', value: formatDate(merchant?.activationDate), icon: 'CheckCircle' }
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Merchant Information</h3>
        {getStatusBadge(merchant?.status)}
      </div>

      <div className="space-y-4">
        {infoItems?.map((item, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className="p-2 rounded-lg bg-muted">
              <Icon name={item?.icon} size={16} className="text-muted-foreground" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground mb-1">{item?.label}</p>
              <p className="text-sm text-foreground font-medium break-words">{item?.value}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Status Actions */}
      {merchant?.status !== 'active' && (
        <div className="mt-6 pt-6 border-t border-border">
          <p className="text-sm text-muted-foreground mb-3">Quick Actions</p>
          <div className="space-y-2">
            {merchant?.status === 'pending' && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => onStatusChange('active')}
                className="w-full flex items-center justify-center gap-2 text-success border-success/20 hover:bg-success/10"
              >
                <Icon name="CheckCircle" size={16} />
                Activate Merchant
              </Button>
            )}
            {merchant?.status === 'suspended' && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => onStatusChange('active')}
                className="w-full flex items-center justify-center gap-2 text-success border-success/20 hover:bg-success/10"
              >
                <Icon name="CheckCircle" size={16} />
                Reactivate Merchant
              </Button>
            )}
            {merchant?.status === 'active' && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => onStatusChange('suspended')}
                className="w-full flex items-center justify-center gap-2 text-error border-error/20 hover:bg-error/10"
              >
                <Icon name="XCircle" size={16} />
                Suspend Merchant
              </Button>
            )}
          </div>
        </div>
      )}

      {/* Churn Risk */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm text-muted-foreground">Churn Risk Score</p>
          <span className="text-sm font-semibold text-foreground">{(merchant?.churnRiskScore || 0)?.toFixed(1)}%</span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className={`h-2 rounded-full transition-all ${
              merchant?.churnRiskScore > 70 ? 'bg-error' :
              merchant?.churnRiskScore > 40 ? 'bg-warning' : 'bg-success'
            }`}
            style={{ width: `${merchant?.churnRiskScore || 0}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default InfoCard;